import GLightbox from 'glightbox';


const videoLightbox = new GLightbox({
    selector: '.hero__play-button'
});